module.exports = __webpack_public_path__ + "img/4.245566d7.png";